/* ============================================================================
 * Louloungerie × Firmhouse — Custom checkout redirect (Arrows route 2)
 * ----------------------------------------------------------------------------
 * WAT DIT DOET
 * Houdt de hele winkelervaring native in Shopify. Pas wanneer de klant op
 * "Afrekenen / Checkout" klikt, kijkt dit script naar de cart:
 *   - Zit er minstens één abonnementsproduct in (bv. de Maandbox)? -> bouw een
 *     Firmhouse advanced-checkout-URL met de juiste maat-slug(s) en stuur de
 *     klant daarheen.
 *   - Zitten er geen abonnementsproducten in? -> gewoon de Shopify-checkout.
 *
 * WAAROM SLUG-AFLEIDING (geen handmatige product-map)
 * De Maandbox is in Shopify één product met ~120 maat-varianten, in Firmhouse
 * elk een eigen product met slug "maandbox-{cup}-slash-{maat}", bv.
 *   Shopify-variant "70A / S"  ->  Firmhouse-slug "maandbox-70a-slash-s"
 * We leiden die slug live af uit de variant, dus nieuwe maten werken vanzelf.
 *
 * INSTALLATIE
 * 1. Shopify admin > Online Store > Themes > ... > Edit code
 * 2. assets/firmhouse-redirect.js aanmaken en deze inhoud plakken.
 * 3. In layout/theme.liquid, vlak vóór </body>:
 *      <script src="{{ 'firmhouse-redirect.js' | asset_url }}" defer></script>
 *
 * EERST TESTEN: zet dit op een THEMA-KOPIE / preview en test de checkout met
 * een echte cart vóór je publiceert. Dit script onderschept ALLE checkout-klikken.
 * ========================================================================== */

(function () {
  "use strict";

  // --- CONFIGURATIE ----------------------------------------------------------

  // Je Firmhouse-checkout-URL (uit Arrows "Choose your custom checkout URL").
  var FIRMHOUSE_CHECKOUT_URL = "https://checkout.firmhouse.com/nl/louloungerie/";

  // Shopify product-handles die als abonnement naar Firmhouse moeten.
  // Voeg hier extra abonnementsproducten toe als die er komen.
  var SUBSCRIPTION_HANDLES = ["maandbox", "kwartaalbox"];

  // Optioneel vast Firmhouse-plan (leeg laten als je dat niet gebruikt).
  var FIRMHOUSE_PLAN = "";

  // Alleen bezoekers uit deze landen gaan naar Firmhouse (iDEAL/SEPA-recurring);
  // alle andere landen rekenen gewoon af via de native Shopify-checkout.
  var FIRMHOUSE_COUNTRIES = ["NL", "BE"];

  // --- HELPERS ---------------------------------------------------------------

  function getCart() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); });
  }

  // IP-gebaseerde landdetectie via Shopify's eigen endpoint (zelfde bron als
  // geolocation-apps). Gecachet in sessionStorage; bij twijfel "" (geen match).
  function getVisitorCountry() {
    try {
      var cached = sessionStorage.getItem("ll_geo_country");
      if (cached) return Promise.resolve(cached);
    } catch (err) { /* private mode e.d. */ }
    return fetch("/browsing_context_suggestions.json", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var c = (d && d.detected_values && d.detected_values.country && d.detected_values.country.handle) || "";
        try { if (c) sessionStorage.setItem("ll_geo_country", c); } catch (err) {}
        return c;
      })
      .catch(function () { return ""; });
  }

  // Bouwt de Firmhouse-slug uit de Shopify-variant.
  // Firmhouse-productnaam = "<ProductTitel> (<variant_title>)"  ->  geslugd met
  // "/" -> "slash". Voorbeeld: "Maandbox" + "70A / S" -> "maandbox-70a-slash-s".
  function firmhouseSlug(productTitle, variantTitle) {
    var name = productTitle + " " + (variantTitle || "");
    return name
      .toLowerCase()
      .replace(/\//g, " slash ")   // "/" wordt het woord "slash"
      .replace(/[^a-z0-9]+/g, "-") // alles wat geen letter/cijfer is -> "-"
      .replace(/^-+|-+$/g, "");    // streepjes aan begin/eind weg
  }

  // Verzamelt de abonnements-slugs (met aantal) uit de cart.
  function collectSubscriptionSlugs(cart) {
    var out = [];
    (cart.items || []).forEach(function (line) {
      if (SUBSCRIPTION_HANDLES.indexOf(line.handle) !== -1) {
        out.push({
          slug: firmhouseSlug(line.product_title, line.variant_title),
          quantity: line.quantity || 1
        });
      }
    });
    return out;
  }

  // Bouwt de advanced-checkout-URL: ?products=slug,slug,...(&plan=...)
  // Per stuk aantal herhalen we de slug (zo verwerkt Firmhouse de hoeveelheid).
  function buildFirmhouseUrl(subs) {
    var slugs = [];
    subs.forEach(function (s) {
      for (var i = 0; i < s.quantity; i++) slugs.push(s.slug);
    });
    var params = ["products=" + encodeURIComponent(slugs.join(","))];
    if (FIRMHOUSE_PLAN) params.push("plan=" + encodeURIComponent(FIRMHOUSE_PLAN));
    var sep = FIRMHOUSE_CHECKOUT_URL.indexOf("?") === -1 ? "?" : "&";
    return FIRMHOUSE_CHECKOUT_URL + sep + params.join("&");
  }

  // Beslist waarheen te redirecten zodra de klant afrekent.
  // Alleen NL/BE-bezoekers mét abonnementsproduct gaan naar Firmhouse;
  // alle andere gevallen (andere landen, geen abo, detectie mislukt) -> Shopify.
  function handleCheckout(e) {
    if (e) { e.preventDefault(); e.stopPropagation(); }
    Promise.all([getCart(), getVisitorCountry()])
      .then(function (results) {
        var cart = results[0];
        var country = results[1];
        var subs = collectSubscriptionSlugs(cart);
        if (subs.length > 0 && FIRMHOUSE_COUNTRIES.indexOf(country) !== -1) {
          window.location.href = buildFirmhouseUrl(subs); // -> Firmhouse
        } else {
          window.location.href = "/checkout";             // -> Shopify
        }
      })
      .catch(function () {
        window.location.href = "/checkout"; // bij twijfel: veilig naar Shopify
      });
  }

  // --- CHECKOUT-KLIKKEN ONDERSCHEPPEN ---------------------------------------

  // Selectors voor checkout-knoppen. Naast de standaard Shopify-knop
  // (name="checkout") ook de "Corner cart"-app-knop (andere winkelwagen-drawer).
  var CHECKOUT_SELECTORS = [
    '[name="checkout"]',
    'button[name="checkout"]',
    'a[href="/checkout"]',
    'a[href$="/checkout"]',
    '#corner-cowi-cart-summary-card-cta-button',          // Corner cart "Bestellen"
    '[aria-label="checkout-call-to-action-button"]'        // Corner cart (semantisch)
  ].join(", ");

  document.addEventListener("click", function (e) {
    var el = e.target.closest(CHECKOUT_SELECTORS);
    if (el) handleCheckout(e);
  }, true);

  document.addEventListener("submit", function (e) {
    var form = e.target;
    var action = form && form.getAttribute("action");
    if (action && action.indexOf("/cart") === 0) {
      var submitter = e.submitter;
      if (submitter && submitter.getAttribute("name") === "checkout") {
        handleCheckout(e);
      }
    }
  }, true);
})();
